import { render, staticRenderFns } from "./indexFinnisRisk.vue?vue&type=template&id=7ce820e4&"
import script from "./indexFinnisRisk.vue?vue&type=script&lang=js&"
export * from "./indexFinnisRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports